
import { supabase } from './client';
import { createAttendeesTable, createAdminActionsTable, createAdminStateTable } from './tables';
import { createStoredProcedures } from './functions';

// Track if tables have been created
let tablesInitialized = false;

// Make createTablesIfNotExist available for external use
export const createTablesIfNotExist = async () => {
  try {
    // Skip if we've already created tables in this session
    if (tablesInitialized) {
      return true;
    }
    
    // Check tables existence without inserting data
    const attendeesCreated = await createAttendeesTable();
    const adminActionsCreated = await createAdminActionsTable();
    const adminStateCreated = await createAdminStateTable();
    
    // Create stored procedures for more reliable database operations
    await createStoredProcedures();
    
    tablesInitialized = attendeesCreated && adminActionsCreated && adminStateCreated;
    return tablesInitialized;
  } catch (error) {
    console.error('Error initializing database tables:', error);
    return false;
  }
};

// Allow forced table creation if needed
export const forceTableCreation = () => {
  tablesInitialized = false;
};
